<script setup>
import router from "@/router/index.js";

const handleBack = () => {
  router.back()
}
</script>

<template>
  <div class="img_box">
    <img class="img_404" src="../../assets/images/404/404.png" alt="">
    <div>
      <strong style="font-size: 32px">404错误!</strong>
    </div>
    <div style="color: #999999;margin-bottom: 20px">
      <span>找不到网页！尝试检查URL的错误，然后按浏览器上的刷新按钮或尝试在我们的应用程序中找到其他内容。</span>
    </div>
    <div>
      <v-btn rounded color="primary" @click="handleBack">返回上一页</v-btn>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.img_box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .img_404 {
    width: 800px;
    height: 500px;
  }
}
</style>